import { render } from "./AppPagination.vue?vue&type=template&id=ede882c8&scoped=true"
import script from "./AppPagination.vue?vue&type=script&lang=js"
export * from "./AppPagination.vue?vue&type=script&lang=js"

import "./AppPagination.vue?vue&type=style&index=0&id=ede882c8&lang=scss&scoped=true"

import exportComponent from "/Users/ferlando/Desktop/Baboon/baboon-pos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ede882c8"]])

export default __exports__